import '.an{position:relative;}.ssr-plugin'
import '.ir{width:64px;}.ssr-plugin'
import '.is{height:64px;}.ssr-plugin'
import '.ah{flex-shrink:0;}.ssr-plugin'
import '.bg{position:absolute;}.ssr-plugin'
import '.it{bottom:-4px;}.ssr-plugin'
import '.if{right:-4px;}.ssr-plugin'
import '.g8{border-radius:50%;}.ssr-plugin'
import '.d0{border:2px solid var(--palette-white);}.ssr-plugin'
import '.bz{overflow:hidden;}.ssr-plugin'
import '.iu{width:32px;}.ssr-plugin'
import '.iv{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="an ir is ah"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bg it if g8 d0 bz iu iv"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
